import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for Firefighters | Neuro Wellness TMS Centers of America",
  description:
    "Firefighters: learn about TMS therapy, SAINT TMS, and mental health treatment options for depression, anxiety, and PTSD in Coral Springs, FL.",
  canonical: "/tms-for-firefighters",
  keywords:
    "TMS for firefighters, firefighter depression treatment, fire department TMS therapy, firefighter PTSD treatment Florida",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "TMS for EMS", href: "/tms-for-ems" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
];

export default function TmsForFirefighters() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Firefighters"
      title="TMS for Firefighters"
      subtitle="Firefighters are exposed to trauma at rates few other professions match. If medication hasn't helped, there are other treatment options."
    >
      <DecisionSection heading="What firefighters experience">
        <p>
          Firefighting means running toward danger that others run from. Over a
          career, the cumulative weight of critical incidents, loss, and
          sustained danger takes a toll. Depression, anxiety, and PTSD are more
          common in firefighters than in the general population — and sleep
          disruption, which is nearly universal in shift work, makes everything
          harder.
        </p>
        <p>
          If you've tried antidepressants without adequate relief, there are
          treatments that work through different mechanisms.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive magnetic stimulation for depression",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression",
            "Prism for PTSD — EEG neurofeedback for PTSD symptoms",
            "IV ketamine and KAP — for depression, anxiety, and PTSD",
            "Trauma-informed psychotherapy",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Confidentiality">
        <p>
          Your treatment is confidential. We do not contact your fire department
          or employer without your written consent. Your records are protected
          by HIPAA.
        </p>
      </DecisionSection>

      <DecisionSection heading="Insurance">
        <p>
          Many firefighters have insurance through their department or union
          plan. Coverage varies by plan. Our team verifies your benefits and
          handles authorization.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
